// import React from 'react';
// import Bgimage from "../../images/Tire/tire.jpg";

// function Tire() {
//     return (
//         <div>
//             <div className="mx-auto text-center md:py-2">
//                 <section
//                     className="w-full bg-cover bg-center bg-no-repeat text-white rounded-lg py-2 md:py-16"
//                     style={{ backgroundImage: `url(${Bgimage})` }}
//                 >
//                     <div className="gap-6 items-center">
//                         <div className="p-2 md:p-6 rounded-lg">
//                             <h2 className="text-3xl md:text-4xl font-bold mb-2">TIRE REINFORCEMENT</h2>
//                             <p className="sm:p-4 md:p-7 rounded-lg text-lg md:text-2xl md:px-28">
//                                 Utilizing high-strength steel for exceptional durability and stability, our tire reinforcement solutions
//                                 provide vital load-bearing support. Perfect for enhancing tire performance in demanding conditions,
//                                 ensuring longevity, safety, and reliability for all your vehicles.
//                             </p>
//                         </div>
//                     </div>
//                 </section>
//             </div>
//         </div>
//     );
// }

// export default Tire;

import React from "react";
import Indusone from "../../images/Product/tire.png";

function OurExpertise() {
    return (
        <div className="w-full">
            {/* Top Section - Image & Text */}
            <div className="mx-auto md:mt-3">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
                    {/* Left Side - Text Content */}
                    <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
                        <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4 text-center">
                            TIRE-REINFORCEMENT
                        </h2>
                        <p className="text-sm md:text-lg mb-6 text-justify">
                        We spend each day in labs dedicated to evolving advanced silanes for the tire industry. We work with the materials that you incorporate into tires to know exactly how various rubber compounds will react in real-life situations. To generate this data, we develop solutions in the Tarrytown, NY, facility, and then fine-tune formulations in a series of rigorous tests at our state-of-the-art rubber lab in Charlotte, NC.
Our team of experts continuously explores innovative approaches to enhance tire performance and durability.
This commitment ensures that our solutions meet the highest standards of safety, efficiency, and sustainability.
                        </p>
                    </div>

                    {/* Right Side - Image */}
                    <div className="lg:col-span-7 flex">
                        <div className="w-full h-[400px] overflow-hidden rounded-lg">
                            <img
                                src={Indusone}
                                alt="Offshore Industry"
                                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurExpertise;


